import request from '@/utils/request'

/**
 * 查询订单费用列表
 * @param {Object} params - 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function queryStoreOrderCartFee(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryStoreOrderCartFee',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}